import { render } from "./PayForgot.vue?vue&type=template&id=1bfe0f73&scoped=true"
import script from "./PayForgot.vue?vue&type=script&lang=js"
export * from "./PayForgot.vue?vue&type=script&lang=js"

import "./PayForgot.vue?vue&type=style&index=0&id=1bfe0f73&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfe0f73"]])

export default __exports__